//FUNCIONS
import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { StoreState } from '../../../store/createStore';
import { routesEndpoints } from '../../../routes/endpoint';
//import { order as onOrder } from '../../../store/modules/order/actions';

//HOOKS
import { useTranslation } from '../../../hooks/useTranslation';
//TYPES

//COMPONENTS
import Loading from '../../../components/Loading';

//STYLES
import {
  Container,
  AnimationContainer,
  ContainerSectionFooter,
  ContainerButtons,
  Button,
  ContainerPix,
} from './styles';
import { useToast } from '../../../hooks/toast';
import { orderCheckoutClear } from '../../../store/modules/checkout/actions';
import PaymentConfirmation from '../../../components/PaymentConfirmation';

const ViewCompletion: React.FC = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { loading, } = useSelector((state: StoreState) => state.order);
  const { error, errorData, loading: loadingCheckout, orderCheckout } = useSelector((state: StoreState) => state.checkout);
  const { onTranslation: t } = useTranslation();
  const { onSetMessage } = useToast();
  const { order } = orderCheckout;

  // const handleGoToOrderDetail = useCallback((orderId: number) => {
  //   dispatch(onOrder(orderId));
  //    dispatch(orderCheckoutClear());
  //   history.push(`${routesEndpoints.ORDERS_DETAIL}?id=${orderId}`);
  // }, [dispatch, history]);

  const handledSideMenuSel = useCallback((menuSel: number) => {
    dispatch(orderCheckoutClear());
    history.push(routesEndpoints.NEW_ACCOUNT_ORDERS);
  }, [dispatch, history]);

  const handledGoHome = useCallback(() => {
    dispatch(orderCheckoutClear());
    history.push(routesEndpoints.HOME);
  }, [dispatch, history]);

  useEffect(() => {
    if (error && errorData) {
      onSetMessage({ type: 'error', description: errorData.message });
      dispatch(orderCheckoutClear());
      history.push(routesEndpoints.HOME);
    }
  }, [dispatch, error, errorData, history, onSetMessage]);

  return (
    <Container>
      <AnimationContainer>
        {!orderCheckout.order.order_id || orderCheckout.order.order_id <= 0 ? (
          <>
            <h2 style={{ color: 'var(--primary)', marginBottom: 10 }}>{t('main.globals.wait')}</h2>
            <h3 style={{ color: 'var(--primary)', marginBottom: 10 }}>{t('main.new_checkout.view_completion.processing_order')}</h3>
            <Loading size={160} />
          </>
        ) : (
          <>
            {/* <FaRegCheckCircle size="160" color="green" />
            <span>{t('main.new_checkout.view_completion.order_finished_sucess')}</span> */}
            {/* <h3 style={{ marginBottom: 10 }}>{order?.status_label}</h3> */}
            <p>
              {t('main.new_checkout.view_completion.your_order_number')} <b>{orderCheckout.order.order_id}</b> {t('main.new_checkout.view_completion.is_finished')}
            </p>
            {/* <p>
              Você pode acompanhar o andamento do seu pedido <span onClick={() => {
                  handleGoToOrderDetail(order.order_id as number)
                }}>aqui</span>
            </p> */}
            <ContainerPix>
              <PaymentConfirmation order={order} />
            </ContainerPix>
            <p> {t('main.globals.thanks')} :)</p>
          </>
        )}
      </AnimationContainer>
      {
        !loading && !loadingCheckout && (
          <ContainerSectionFooter>
            <ContainerButtons>
              <Button onClick={handledGoHome} bgColor="#e22301" fgColor="#FFFFFF" disabled={loading}>
                <span>{t('main.new_checkout.view_completion.keep_buying')}</span>
              </Button>
              <Button onClick={() => handledSideMenuSel(3)} bgColor="#00b300" fgColor="#FFFFFF" disabled={loading}>
                <span>{t('main.new_checkout.view_completion.my_orders')}</span>
              </Button>
            </ContainerButtons>
          </ContainerSectionFooter>
        )
      }

    </Container>
  );
}

export default ViewCompletion;
